export const HTTP_REQUEST_SUCCESS = 'HTTP_REQUEST_SUCCESS';
export const HTTP_REQUEST_ERROR = 'HTTP_REQUEST_ERROR';
export const WITH_LOGGED_USER_ID = 'WITH_LOGGED_USER_ID';
